import { Baskets } from 'shared/presenters/graphqlTypes'
import { gql, useQuery } from '@apollo/client'
import { ON_SERVER } from 'shared/enums/environment'
import storageApi from 'helpers/storageApi'
import { MEMBERSHIPS_CHARGEABLE_TYPE } from 'shared/enums/memberships'
import { HttpHeader } from 'shared/enums/httpHeader'

interface UseBasketContainsMembership {
  widgetSlug: string
}

const useBasketContainsMembership = ({
  widgetSlug
}: UseBasketContainsMembership) => {
  const basketId = storageApi?.getBasketId?.(widgetSlug) ?? null
  const { data: basketData } = useQuery<{
    baskets: Baskets[]
  }>(FETCH_BASKET_CONTAINS_MEMBERSHIP, {
    variables: {
      basketId
    },
    context: { headers: { [HttpHeader.xHasuraBasketId]: basketId } },
    skip: ON_SERVER || !basketId,
    ssr: ON_SERVER
  })

  return basketData?.baskets[0]?.line_items_aggregate?.aggregate?.count == 1
}

export default useBasketContainsMembership

export const FETCH_BASKET_CONTAINS_MEMBERSHIP = gql`
  query WidgetUseBasketContainsMembershipFetchBasket($basketId: uuid) {
    baskets(where: { id: { _eq: $basketId } }) {
      line_items_aggregate(
        where: { chargeable_type: { _eq: "${MEMBERSHIPS_CHARGEABLE_TYPE}" } }
      ) {
        aggregate {
          count
        }
      }
    }
  }
`
